import ReactGA from 'react-ga4';
import { useEffect } from 'react';
import { log } from './lib/logger';

const FIVE_MINUTES_MS = 5 * 60 * 1000;
const FIFTEEN_MINUTES_MS = 15 * 60 * 1000;

const sendHeartbeat = (label) => {
  ReactGA.event({
    category: 'Heartbeat',
    action: 'Heartbeat Event',
    label,
    value: 0,
  });
  log.debug('Heartbeat Event Sent - Label:', label);
};

// Watch-time heartbeats: one at 5 minutes, then one every 15 minutes labelled with the running
// total ("15 minutes", "30 minutes", ...). One timeout and one interval for the component's life.
const HeartbeatTracker = () => {
  useEffect(() => {
    let minutes = 15;
    const firstTimer = setTimeout(() => sendHeartbeat('5 Minute Interval'), FIVE_MINUTES_MS);
    const intervalTimer = setInterval(() => {
      sendHeartbeat(`${minutes} minutes`);
      minutes += 15;
    }, FIFTEEN_MINUTES_MS);

    return () => {
      clearTimeout(firstTimer);
      clearInterval(intervalTimer);
    };
  }, []);

  return null;
};

export default HeartbeatTracker;
